export enum ClaimFunnelRoutesEnum {
    ClaimFunnelBase = 'verzekeringsmap/mijn-schades/schademelden',
    Categories = 'categories',
    Situation = 'situation',
    Overview = 'overview',
    Information = 'information',
    Coverage = 'coverage',
    Compensation = 'compensation',
    Appointment = 'appointment',
    Objects = 'objects',
    Thanks = 'thanks',
    Documents = 'documents',
    Parties = 'parties',
    ReceiveUpdates = 'receive-updates',
    NoInsurance = 'no-insurance',

    // Old claim funnel, this will be removed when the new claim funnel is live
    OldClaimFunnel = '/mijn-verzekeringsmap/schaderegelen#/schademelden',
}
